import type { Stylable, WithRouterUrl } from '@core/utils/types'
import { Tabs as ShadcnTabs, TabsList, TabsTrigger } from '@design/ui/tabs'
import { Link } from '@tanstack/react-router'
import type { LucideIcon } from 'lucide-react'

export interface NavigationTabItem extends Omit<WithRouterUrl, 'url'> {
  value: string
  label: string
  url?: string
  icon?: LucideIcon
  onClick?: () => void
  disabled?: boolean
}

interface NavigationTabsProps extends Stylable {
  activeTab: string
  items: NavigationTabItem[]
}

export function NavigationTabs({
  activeTab,
  items,
  className,
}: NavigationTabsProps) {
  return (
    <ShadcnTabs value={activeTab} className={className}>
      <TabsList className='bg-background'>
        {items.map(
          ({
            value,
            label,
            icon: Icon,
            url,
            search,
            urlParams,
            onClick,
            disabled,
          }) => (
            <TabsTrigger
              key={value}
              value={value}
              className='gap-2 data-[state=active]:bg-muted'
              disabled={disabled}
              onClick={onClick}
              asChild={!!url}
            >
              {url ? (
                <Link to={url} search={search} params={urlParams}>
                  {Icon && <Icon className='size-4' />}
                  {label}
                </Link>
              ) : (
                <>
                  {Icon && <Icon className='size-4' />}
                  {label}
                </>
              )}
            </TabsTrigger>
          )
        )}
      </TabsList>
    </ShadcnTabs>
  )
}
